/** @deprecated - Use new RootModalsContext instead */
import createModalsContext from '~/domains/common/context/createModalsContext';

import type { ModalType } from './types';

const { ModalsContext, ModalsContextProvider } = createModalsContext<ModalType>();

export { ModalsContext as RootModalsContext, ModalsContextProvider as RootModalsContextProvider };
